import { Outlet, createRootRoute } from "@tanstack/react-router";
import { ErrorComponent } from "~/components/router/error";

export const Route = createRootRoute({
  component: RootComponent,
  errorComponent: ErrorComponent,
});

function RootComponent() {
  return (
    <div className="flex min-h-dvh w-full">
      <Outlet />
    </div>
  );
}
